import { createContext, useContext } from "react";
const DropdownActionsContext = createContext(
  {
    onChange: () => {
    },
    onClose: () => {
    },
    multi: !1
  }
), DropdownContext = createContext({
  multi: !1
}), useDropdownActionsContext = () => useContext(DropdownActionsContext), useDropdownContext = () => useContext(DropdownContext);
export {
  DropdownActionsContext,
  DropdownContext,
  useDropdownActionsContext,
  useDropdownContext
};
//# sourceMappingURL=DropdownContext.js.map
